import React, { useState } from 'react';
import { Box, Button, Link, Alert } from '@mui/material';
import { authService } from '../../services/auth.service';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthSplitLayout, authFooterSx } from './AuthSplitLayout';
import { AuthTextField } from './AuthTextField';
import { GoogleSignInButton } from './GoogleSignInButton';

export const RegisterForm = () => {
  const { t } = useTranslation('auth');
  const [form, setForm] = useState({ username: '', password: '', email: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      await authService.register(form);
      setSuccess(t('register.success'));
    } catch (err: any) {
      setError(err.response?.data?.message || t('register.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthSplitLayout title={t('register.title')} subtitle={t('register.subtitle')}>
      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2.25 }}>
        <AuthTextField
          label={t('fields.username')}
          autoComplete="username"
          value={form.username}
          onChange={e => setForm({ ...form, username: e.target.value })}
          required
        />
        <AuthTextField
          label={t('fields.email')}
          type="email"
          autoComplete="email"
          value={form.email}
          onChange={e => setForm({ ...form, email: e.target.value })}
          required
        />
        <AuthTextField
          type="password"
          label={t('fields.password')}
          autoComplete="new-password"
          value={form.password}
          onChange={e => setForm({ ...form, password: e.target.value })}
          required
        />
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <Button fullWidth variant="contained" type="submit" disabled={loading} sx={{ height: 42, mt: 0.5 }}>
          {loading ? t('register.submitting') : t('register.submit')}
        </Button>
        <GoogleSignInButton mode="signup" />
        <Box sx={authFooterSx}>
          {t('register.haveAccount')}{' '}
          <Link component={RouterLink} to="/login" underline="hover">{t('register.signIn')}</Link>
        </Box>
      </Box>
    </AuthSplitLayout>
  );
};
